import PhysicalVerificationMonitor from 'ui-component/cards/PhysicalVerification/PhysicalVerificationMonitor';

const SHPVMonitorPage = () => {
    return <PhysicalVerificationMonitor />;
};

export default SHPVMonitorPage;
